<nb-tabset fullWidth>
    <nb-tab *ngFor="let tab of field.fieldGroup; let i = index;" [tabTitle]="tab.templateOptions.tabTitle"
        [active]="activeTab[i]">
        <formly-field [field]="tab"></formly-field>
    </nb-tab>
</nb-tabset>
